import { render, staticRenderFns } from "./EventWall.vue?vue&type=template&id=3aa43238"
import script from "./EventWall.vue?vue&type=script&lang=js"
export * from "./EventWall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports